export interface EslintProject {
    readonly preset: "softwareventures" | "other";
}
